/**
 * An audit's data scope, as words — the conditions and the chosen files.
 *
 * The description is built by the server (`backend/src/services/dataScope.ts`)
 * from the stored filter, so the Data tab, the report, the printed report and
 * every Excel workbook's About sheet say exactly the same thing. This screen
 * component only lays it out.
 *
 * A scope locked before filters were stored is "not recorded" — never "every
 * row", which would be a specific and possibly false claim.
 */

import { Note } from '../../shared/ui';
import type { DataScope } from '../../schemas';

export function DataScopeSummary({ scope }: { scope: DataScope }) {
	if (!scope.recorded) {
		return (
			<Note tone="info" title="Not recorded" row>
				This scope was locked before data scopes were stored.
			</Note>
		);
	}
	const nothing = scope.conditions.length === 0 && scope.files.length === 0;
	if (nothing) return <p>Every processed row for this client.</p>;
	return (
		<ul className="stack2" style={{ margin: 0, paddingLeft: '1.1em' }}>
			{scope.conditions.map((condition) => (
				<li key={condition}>{condition}</li>
			))}
			{scope.files.length > 0 && (
				<li>
					{scope.files.length === 1
						? 'File: '
						: `Files (${scope.files.length}): `}
					{scope.files.map((file) => file.name).join(', ')}
				</li>
			)}
		</ul>
	);
}
